<script setup lang="ts">
import {computed, ref} from 'vue';
import LegacyOrderView from '@/views/LegacyOrder/LegacyOrderView.vue';
import {LegacyOrder, useContext} from '@hantera/portal-app';
import {createKeyboardCaptureContext} from "@/composition/keyboard";

const context = useContext()
const orderElem = ref<typeof LegacyOrderView>();

const orderId = computed(() => {
  const currentView = context.currentView.value! 
  return currentView.query.id!
})

createKeyboardCaptureContext(
  _ => context.currentView.value!.active
);

function load(result: LegacyOrder) {
  context.currentView.value!.name.value = result.orderNumber;
}

function openOrder(order: LegacyOrder) {
  context.openView(
    '/legacy-order',
    {
      query: {
        id: order.orderId
      }
    }
  )
}

function saveStateChanged(value: boolean) {
  context.currentView.value!.hasPendingChanges.value = value
}

</script>

<template>
  <div class="order-pane">
    <KeepAlive>
      <LegacyOrderView
        :order-id="orderId"
        :key="orderId"
        v-model:selected-tab="context.currentView.value!.state.selectedTab"
        @load="load"
        @open-order="openOrder"
        @save-state-changed="saveStateChanged"
        ref="orderElem"
      />
    </KeepAlive>
  </div>
</template>

<style scoped>
.order-pane {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>